import styled from 'styled-components';

export default styled.button`
  width: 100%;
  height: 49px;
  padding: 15px 24px;
  border-radius: 15px;
  border: 0;
  background-color: ${props => (props.disabled ? '#6e6e6e' : '#3143fd')};
  color: #ffffff;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  transition: all 0.2s ease;
  outline: none;

  &:hover:not(:disabled) {
    background-color: #4255ff;
    border-color: #2334c8;
  }

  &:active:not(:disabled) {
    background-color: #2030e0;
  }

  svg {
    width: 20px;
    height: 20px;
    fill: #ffffff;
  }

  img {
    width: 20px;
    height: 20px;
    display: block;
  }
`;
